import { z } from "zod";
import { INBOX_FILTERS } from "../../../shared/schemas/notifications";

/** The Inbox's address (BUILD_SPEC §12.8): which of its views, and the issue in its peek. */
export const inboxSearchSchema = z.object({
  filter: z.enum(INBOX_FILTERS).optional().catch(undefined),
  issue: z.string().min(1).optional().catch(undefined),
});
export type InboxSearch = z.infer<typeof inboxSearchSchema>;
